// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"14fffcbb","831":"c9de1f11"}[chunkId] + ".chunk.js";
};